module.exports = __webpack_public_path__ + "img/step_7.6a8d11ca.png";